import React from 'react'
import LayoutSidebar from '../components/LayoutSidebar'

export default function ModuleList() {
  return (
    <LayoutSidebar
      contentTitle={` Home `}
      content={(
        <p data-testid="home-welcome">Welcome to lendox.</p>
      )}
    />
  )
}
